import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  width: '100%',
  marginBottom: (p) => p.spacing(1.5),
};

export const alert: SxStyle = {
  alignItems: 'center',
  width: '100%',
};

export const body: SxStyle = {
  display: 'flex',
  flexDirection: 'column',
  gap: (p) => p.spacing(0.5),
};
